import { ItemBuySubscription } from "@/models/payment";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";



export interface IPaymentSlice {
  paymentAction: string;
  buySubscriptions: ItemBuySubscription[];
}

const initialState: IPaymentSlice = {
  paymentAction: "",
  buySubscriptions: []
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPaymentAction: (state, action: PayloadAction<string>) => {
      state.paymentAction = action.payload;
    },  
    setBuySubscription: (state, action: PayloadAction<ItemBuySubscription[]>) => {
      state.buySubscriptions = action.payload;
    },  
  },
});

export const {setPaymentAction, setBuySubscription} = paymentSlice.actions;
export default paymentSlice.reducer;
